export interface TableTopInfo {
  betAmount: number;
  winAmount: number;
  multiplier: string;
  nickname: string;
  betTime: string;
  cashOutMultiplier: number;
  index: number;
  gameEndTime: string;
}

export enum TableTopTab {
  CASHED_MULTIPLIERS = 'cashouts',
  WINS = 'wins',
  RESULTS = 'multipliers',
}
